import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';
import Processing from '../../components/Processing';

import AddressDisplay from './AddressDisplay';
import { EditAddressForm } from './EditAddress';

import BackIcon from '../../images/icons/back-button.svg';

export default class AddressEditingModal extends React.Component {
  static propTypes = {
    save: PropTypes.func.isRequired,
    addressList: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.addressListing = this.addressListing.bind(this);
    this.addressAdd = this.addressAdd.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveAddress = this.saveAddress.bind(this);

    this.state = {
      addAddress: false,
      error: null,
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      postal_code: '',
      instructions: ''
    };
  }

  addressListing() {
    let addresses = this.props.addressList.map(address =>
      <div className="address-display-entry" key={`address-${address.token}`}>
        <AddressDisplay address={address} />
        <div className="use-this-address link" onClick={() => this.props.setSelectedAddress(address.token)}>Use This Address</div>
      </div>
    );

    return (
      <div>
        <div className="address-listing">{addresses}</div>
        <div className="button-box">
          <Button className="full-width" onClick={() => this.setState({ addAddress: true })}>Add New Address</Button>
        </div>
      </div>
    );
  }

  addressAdd() {
    let error = null;
    if (this.state.error) error = <div className="error-container"><div className="error">{this.state.error.message}</div></div>;

    return (
      <div>
        <div className="back-button link" onClick={() => this.setState({ addAddress: false })}><img role="presentation" src={BackIcon} /></div>
        {error}
        <EditAddressForm address={this.state} onChange={this.onChange}/>
        <div className="button-box">
          <Button className="full-width" onClick={this.saveAddress} waitingState={<Processing />}>Save</Button>
        </div>
      </div>
    );
  }

  saveAddress() {
    let address = {
      name: this.state.name,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      postal_code: this.state.postal_code,
      instructions: this.state.instructions
    };

    return this.props.save(address).catch(error => this.setState({ error }));
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    return (
      <div className="address-editing-component">
        <h2>Edit Shipping Information</h2>
        {this.state.addAddress ? this.addressAdd() : this.addressListing()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/checkout/AddressEditingModal.js
 **/